import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppBaseComponent } from '../../app-base.component';
import { EnumDescriptor } from '../../enum-descriptor';
import { EvaluationState } from '@proxy/evaluations';

@Component({
    selector: 'app-evaluation-state-dropdown',
    templateUrl: './evaluation-state-dropdown.component.html',
    standalone: false
})
export class EvaluationStateDropdownComponent extends AppBaseComponent implements OnInit {
  @Input() isRequired: boolean;
  @Input() isReadOnly: boolean;
  @Input() evaluationState: EvaluationState;

  @Output() changeEvaluationState = new EventEmitter<EvaluationState>();

  evaluationStates: EnumDescriptor[];

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.loadEvaluationState();
    this.onSelected();
  }

  loadEvaluationState(): void {
    this.evaluationStates = this.getEnumOptions(EvaluationState, false);
  }

  onSelected(): void {
    this.changeEvaluationState.emit(this.evaluationState);
  }
}
